<template>
    <svg viewBox="0 0 26 27" :height="height" :width="width" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Resources</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="HP-001-Redesigned" transform="translate(-1305.000000, -19.000000)" fill-rule="nonzero" stroke="#FFFFFF" stroke-width="2">
            <g id="header_convo_default-copy-5">
                <g id="Right-Icons" transform="translate(1051.000000, 0.500000)">
                    <g id="Quick-Links" transform="translate(254.000000, 19.000000)">
                        <g id="Group-4">
                            <rect id="Rectangle" x="1" y="1" width="10" height="10" rx="2"></rect>
                            <rect id="Rectangle-Copy-14" x="15" y="1" width="10" height="10" rx="2"></rect>
                            <rect id="Rectangle-Copy-16" x="1" y="15" width="10" height="10" rx="2"></rect>
                            <rect id="Rectangle-Copy-15" x="15" y="15" width="10" height="10" rx="2"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
    </svg>
</template>
<script>
    export default {
        name: 'IconGrid',
        props: {
            width: {
                type: [Number, String],
                default: 20,
            },
            height: {
                type: [Number, String],
                default: 20,
            },
        },
    };
</script>
